// extracted by mini-css-extract-plugin
module.exports = {"root":"EJYgm","galleryWrapper":"_15I52","changing_background":"_1Wapy","changingBackground":"_1Wapy"};